import request from "../../utils/request";
import { Result } from "../../models/general";
import { UserSkillInput, UserSkillView, SkillView, SkillFilterInput, SkillInventoryView, SkillEvidenceView } from "../../models/employee";

export async function getUserSkills(userId: string) {
    const response = await request.get<Result<UserSkillView[]>>(`Skill/GetUserSkills/${userId}`);
    return response.data;
}

export async function addUserSkill(input: UserSkillInput) {
    const response = await request.post<Result<UserSkillView>>("Skill/AddUserSkill", input);
    return response.data;
}

export async function editUserSkill(userSkillId: number, input: UserSkillInput) {
    const response = await request.post<Result<UserSkillView>>(`Skill/EditUserSkill/${userSkillId}`, input);
    return response.data;
}

export async function deleteUserSkill(userSkillId: number) {
    const response = await request.post<Result<UserSkillView[]>>(`Skill/DeleteUserSkill/${userSkillId}`);
    return response.data;
}

export async function searchSkills(searchTerm: string) {
    const response = await request.get<Result<SkillView[]>>(`Skill/SearchSkills?searchTerm=${encodeURIComponent(searchTerm)}`);
    return response.data;
}

export async function getCompanySkillsInventory(filter?: SkillFilterInput) {
    const response = await request.post<Result<SkillInventoryView[]>>(
        "Skill/GetCompanySkillsInventory",
        filter ?? {}
    );
    return response.data;
}

export async function getCompanyJobTitles(): Promise<Result<string[]>> {
    const response = await request.get<Result<string[]>>("Skill/GetCompanyJobTitles");
    return response.data;
}

export async function getSkillEvidence(userSkillId: number): Promise<Result<SkillEvidenceView[]>> {
    const response = await request.get<Result<SkillEvidenceView[]>>(`Skill/GetSkillEvidence/${userSkillId}`);
    return response.data;
}
